module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/Observable","commonjs2":"rxjs/Observable","amd":"rxjs/Observable"}
// module id = 5
// module chunks = 0 1